
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ProductResource } from './product.resource.service';

@Injectable()
export class ProductResolver  {

  constructor(private service: ProductResource) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    return new Observable(observer => {
      const productkey = route.parent.params.productkey || route.params.productkey;
      this.service.getOne({ productkey, 'producttranslations.language1': localStorage.getItem('prefLanguage') }).then((result) => {
        observer.next(result);
        observer.complete();
      });
    });
  }
}
